<template>
  <form
    v-on:submit.prevent="findUser(userId)"
    :class="{
      'user-search--home': home,
      'user-search--header': header,
      'my-2': true,
      'pr-2 pl-4 py-2': true,
      'has-error': error === true,
      'no-error': error === false
    }"
  >
    <input
      v-on:input="validateID(userId)"
      :class="{
        'subheading': subheading,
        'body-2': body2,
        'font-weight-light': fontWeightLight,
        'white--text': whiteText
       }"
      placeholder="введите ID студента"
      v-model="userId"
    >
    <v-icon :size="iconSize" color="warning" class="ml-2">search</v-icon>
  </form>
</template>

<script>
  export default {
    name: "UserSearch",
    props: [
      "home",
      "header",
      "iconSize",
      "subheading",
      "body2",
      "fontWeightLight",
      "isPaddingX",
      "whiteText"
    ],
    data() {
      return {
        userId: null,
        error: null
      }
    },
    methods: {
      findUser(userId) {
        if (this.error) {
          return false;
        }

        this.$router.push({name: "dossier", params: {id: userId}});
        this.userId = null;
        this.error = null;
      },

      validateID(userId) {
        this.error = !/^\d+$/.test(userId);
      }
    }
  }
</script>

<style>
  .user-search--home {
    display: flex;
    border: 2px solid #ffffff;
    border-radius: 30px;
    width: 40%;
  }

  .user-search--header {
    display: flex;
    border: 1px solid #dddddd;
    border-radius: 30px;
  }

  .user-search::placeholder {
    color: #ffffff;
  }

  input {
    outline: none !important;
    width: 100%;
  }

  .has-error {
    border-color: #F44336;
  }

  .no-error {
    border-color: #4CAF50;
  }
</style>